import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateTextBlockSplit(section, blocks, textLines, hr) {

  // Inidividual tweens
  // Col-6 Blocks
  let blocksTween = blocks ? gsap.to(blocks, {
    duration: 0.4,
    x: 0,
    opacity: 1,
    stagger: {
      each: 0.5,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated HR
  let hrTween = hr ? gsap.to(hr, {
    duration: 0.4, 
    width: "100%", 
    opacity: 1
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .addLabel("textBlockSplitStart")
    .add(blocksTween, "textBlockSplitStart")
    .add(hrTween, "textBlockSplitStart")
    .add(textLinesTween, "textBlockSplitStart");
}
